import { isArray } from './array';
export const isNumeric = (value) => value != null &&
    value != undefined &&
    !isArray(value) &&
    value !== '' &&
    !isNaN(Number(value.toString()));
//# sourceMappingURL=isNumeric.js.map